export default "__VITE_ASSET__CPEOnBiT__"